(function () {
  var COPIED_CLASS = 'ff-dc__copy-btn--copied';
  var COPIED_DURATION = 2500;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function initBlock(root) {
    var btn = root.querySelector('.ff-dc__copy-btn');
    var timerContainer = root.querySelector('.ff-dc__timer-container');
    var endDateStr = root.dataset.endDate;
    var endTime = endDateStr ? new Date(endDateStr).getTime() : NaN;

    if (!isNaN(endTime) && endTime <= Date.now()) {
      root.hidden = true;
      return;
    }

    root.classList.add('ff-dc__wrapper--ready');

    if (btn) {
      btn.addEventListener('click', function () {
        var code = btn.dataset.code;
        if (!code) return;
        navigator.clipboard.writeText(code).then(function () {
          btn.classList.add(COPIED_CLASS);
          setTimeout(function () { btn.classList.remove(COPIED_CLASS); }, COPIED_DURATION);
        });
      });
    }

    if (timerContainer && !isNaN(endTime)) {
      var daysEl = timerContainer.querySelector('[data-ff-unit="days"]');
      var hoursEl = timerContainer.querySelector('[data-ff-unit="hours"]');
      var minsEl = timerContainer.querySelector('[data-ff-unit="minutes"]');
      var secsEl = timerContainer.querySelector('[data-ff-unit="seconds"]');

      function tick() {
        var diff = endTime - Date.now();
        if (diff <= 0) {
          clearInterval(interval);
          root.classList.add('ff-dc__wrapper--hiding');
          root.addEventListener('animationend', function () { root.hidden = true; }, { once: true });
          return;
        }
        daysEl.textContent = pad(Math.floor(diff / 86400000));
        hoursEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
        minsEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
        secsEl.textContent = pad(Math.floor((diff % 60000) / 1000));
      }

      tick();
      var interval = setInterval(tick, 1000);
    }
  }

  function initAll() {
    document.querySelectorAll('[id^="ff-dc-"]').forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
